import React, { useState } from "react";
import Dashboard from "components/dashboard";
import { PageSection, PageHeaderBar } from "components/page";
import DeploymentPaginatedTable, { query as deploymentsQuery } from "./table";
import { parsePage } from "components/table";
import ActionButtons from "./list-page";
import { AutocompleteConnected } from "components/autocomplete";
import { useCurrentCustomerContext } from "components/current-customer-context";

const DeploymentListPage = ({ location: { search }, intl }) => {
  const { currentCustomerId } = useCurrentCustomerContext();
  const [filter, setFilter] = useState("");

  return (
    <Dashboard>
      <PageHeaderBar title="app.page.deployment.list" buttons={<ActionButtons />} />
      <PageSection spaced>
        <AutocompleteConnected
          onChange={setFilter}
          variables={{ customerId: currentCustomerId }}
          gqlQuery={deploymentsQuery}
          getElementsFromDataHandler={data => data.deployments}
          getSuggestionValue={item => item.description}
          placeholder={intl.formatMessage({ id: "app.page.deployment.list.search" })}
          label={intl.formatMessage({ id: "app.page.deployment.list.search.label" })}
        />
      </PageSection>

      <PageSection spaced hideBackground>
        <DeploymentPaginatedTable
          debounce
          variables={{ description: filter }}
          page={parsePage({ queryParams: search })}
        />
      </PageSection>
    </Dashboard>
  );
};

export default DeploymentListPage;
